import { render, staticRenderFns } from "./ModifyPasswordModal.vue?vue&type=template&id=2e82d0da&scoped=true&"
import script from "./ModifyPasswordModal.vue?vue&type=script&lang=js&"
export * from "./ModifyPasswordModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e82d0da",
  null
  
)

export default component.exports